import { z } from 'zod'

import { StringDtoSchema } from '../base'

export const OnboardingUserDetailsDtoSchema = z.strictObject({
  first_name: StringDtoSchema,
  last_name: StringDtoSchema,
  email: StringDtoSchema.email(),
})

export type OnboardingUserDetailsDto = z.infer<typeof OnboardingUserDetailsDtoSchema>
